import { IMAGE_RESIZE_SPEC } from '@core/image'
import { IconAudacityLockupColored, ResponsiveImage } from '@ds/components'

import musehubButton from './assets/download-on-musehub-btn.png'
import styles from './MadeWithAudacityBanner.module.css'

type TMadeWithAudacityBannerProps = {
    label: string
    logoAlt: string
    ctaAlt: string
    audacityHref: string
    downloadHref: string
    onCtaClick: () => void
}

// Desktop-only, as in audio-web: the banner is hidden below 1280px rather than not rendered.
export const MadeWithAudacityBanner = ({
    label,
    logoAlt,
    ctaAlt,
    audacityHref,
    downloadHref,
    onCtaClick,
}: TMadeWithAudacityBannerProps) => (
    <div className={styles.banner}>
        <div className={styles.info}>
            <a href={audacityHref} target="_blank" rel="noopener noreferrer" aria-label={logoAlt}>
                <IconAudacityLockupColored className={styles.audacityLockup} />
            </a>
            <p className={styles.label}>{label}</p>
        </div>
        <a
            href={downloadHref}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onCtaClick}
            className={styles.cta}
        >
            <ResponsiveImage
                src={musehubButton}
                width={142}
                height={47}
                alt={ctaAlt}
                resize={IMAGE_RESIZE_SPEC}
            />
        </a>
    </div>
)
